export interface GasStation {
  id: string
  code: string // Code unique de la station
  name: string
  location: string
  commune: string
  riverSide: 'RG' | 'RD'
  pumps: number
  prices: {
    essence: number
    diesel: number
    gpl?: number
  }
  capacity: number
  managerContact: string
  fuelAvailability: {
    essence: boolean
    diesel: boolean
    gpl?: boolean
  }
  openingHours: string
  isOperational: boolean
}
export const bamakoStations: GasStation[] = [
  {
    id: '1',
    code: 'TE-HAM',
    name: 'Total Energies Hamdallaye',
    location: 'ACI 2000, Hamdallaye',
    commune: 'Commune IV',
    riverSide: 'RG',
    pumps: 8,
    prices: {
      essence: 750,
      diesel: 680,
      gpl: 520,
    },
    capacity: 50000,
    managerContact: '+223 76 12 34 56',
    fuelAvailability: {
      essence: true,
      diesel: true,
      gpl: true,
    },
    openingHours: '06:00 - 22:00',
    isOperational: true,
  },
  {
    id: '2',
    code: 'SH-BAD',
    name: 'Shell Badalabougou',
    location: 'Avenue Cheick Zayed, Badalabougou',
    commune: 'Commune III',
    riverSide: 'RG',
    pumps: 6,
    prices: {
      essence: 745,
      diesel: 675,
    },
    capacity: 40000,
    managerContact: '+223 76 23 45 67',
    fuelAvailability: {
      essence: true,
      diesel: false,
    },
    openingHours: '06:00 - 23:00',
    isOperational: true,
  },
  {
    id: '3',
    code: 'OE-HIP',
    name: 'Oryx Energies Hippodrome',
    location: 'Route de Koulikoro, Hippodrome',
    commune: 'Commune II',
    riverSide: 'RG',
    pumps: 6,
    prices: {
      essence: 740,
      diesel: 670,
    },
    capacity: 35000,
    managerContact: '+223 76 34 56 78',
    fuelAvailability: {
      essence: true,
      diesel: true,
    },
    openingHours: '05:30 - 22:30',
    isOperational: true,
  },
  {
    id: '4',
    code: 'TE-BCO',
    name: 'Total Energies Bamako Coura',
    location: 'Boulevard du Peuple, Bamako Coura',
    commune: 'Commune I',
    riverSide: 'RG',
    pumps: 5,
    prices: {
      essence: 750,
      diesel: 680,
    },
    capacity: 30000,
    managerContact: '+223 76 45 67 89',
    fuelAvailability: {
      essence: true,
      diesel: true,
    },
    openingHours: '06:00 - 21:00',
    isOperational: false,
  },
  {
    id: '5',
    code: 'SH-LAF',
    name: 'Shell Lafiabougou',
    location: 'Route de Koulikoro, Lafiabougou',
    commune: 'Commune V',
    riverSide: 'RD',
    pumps: 7,
    prices: {
      essence: 745,
      diesel: 675,
      gpl: 515,
    },
    capacity: 45000,
    managerContact: '+223 76 56 78 90',
    fuelAvailability: {
      essence: true,
      diesel: true,
      gpl: false,
    },
    openingHours: '06:00 - 22:00',
    isOperational: true,
  },
  {
    id: '6',
    code: 'TE-MAG',
    name: 'Total Energies Magnambougou',
    location: 'Magnambougou Projet',
    commune: 'Commune VI',
    riverSide: 'RD',
    pumps: 6,
    prices: {
      essence: 750,
      diesel: 680,
    },
    capacity: 38000,
    managerContact: '+223 76 67 89 01',
    fuelAvailability: {
      essence: false,
      diesel: true,
    },
    openingHours: '06:00 - 22:00',
    isOperational: true,
  },
  {
    id: '7',
    code: 'OE-SOT',
    name: 'Oryx Energies Sotuba',
    location: 'Route de Sotuba',
    commune: 'Commune I',
    riverSide: 'RG',
    pumps: 5,
    prices: {
      essence: 740,
      diesel: 670,
    },
    capacity: 32000,
    managerContact: '+223 76 78 90 12',
    fuelAvailability: {
      essence: true,
      diesel: true,
    },
    openingHours: '06:00 - 21:30',
    isOperational: true,
  },
  {
    id: '8',
    code: 'TE-PTG',
    name: 'Total Energies Point G',
    location: 'Quartier du Point G',
    commune: 'Commune II',
    riverSide: 'RG',
    pumps: 6,
    prices: {
      essence: 750,
      diesel: 680,
    },
    capacity: 36000,
    managerContact: '+223 76 89 01 23',
    fuelAvailability: {
      essence: true,
      diesel: false,
    },
    openingHours: '06:00 - 22:00',
    isOperational: true,
  },
  {
    id: '9',
    code: 'SH-KAL',
    name: 'Shell Kalaban Coura',
    location: 'Kalaban Coura ACI',
    commune: 'Commune V',
    riverSide: 'RD',
    pumps: 7,
    prices: {
      essence: 745,
      diesel: 675,
      gpl: 520,
    },
    capacity: 42000,
    managerContact: '+223 76 90 12 34',
    fuelAvailability: {
      essence: true,
      diesel: true,
      gpl: true,
    },
    openingHours: '05:30 - 23:00',
    isOperational: true,
  },
  {
    id: '10',
    code: 'TE-DJI',
    name: 'Total Energies Djicoroni Para',
    location: 'Djicoroni Para',
    commune: 'Commune IV',
    riverSide: 'RG',
    pumps: 5,
    prices: {
      essence: 750,
      diesel: 680,
    },
    capacity: 28000,
    managerContact: '+223 76 01 23 45',
    fuelAvailability: {
      essence: true,
      diesel: true,
    },
    openingHours: '06:00 - 21:00',
    isOperational: true,
  },
  {
    id: '11',
    code: 'OE-QUI',
    name: 'Oryx Energies Quinzambougou',
    location: 'Quinzambougou',
    commune: 'Commune III',
    riverSide: 'RG',
    pumps: 6,
    prices: {
      essence: 740,
      diesel: 670,
    },
    capacity: 34000,
    managerContact: '+223 76 12 34 56',
    fuelAvailability: {
      essence: true,
      diesel: true,
    },
    openingHours: '06:00 - 22:00',
    isOperational: false,
  },
  {
    id: '12',
    code: 'SH-FAL',
    name: 'Shell Faladiè',
    location: 'Faladiè SEMA',
    commune: 'Commune VI',
    riverSide: 'RD',
    pumps: 8,
    prices: {
      essence: 745,
      diesel: 675,
      gpl: 515,
    },
    capacity: 52000,
    managerContact: '+223 76 23 45 67',
    fuelAvailability: {
      essence: true,
      diesel: true,
      gpl: true,
    },
    openingHours: '06:00 - 23:00',
    isOperational: true,
  },
  {
    id: '13',
    code: 'TE-MIS',
    name: 'Total Energies Missira',
    location: 'Missira',
    commune: 'Commune II',
    riverSide: 'RG',
    pumps: 5,
    prices: {
      essence: 750,
      diesel: 680,
    },
    capacity: 30000,
    managerContact: '+223 76 34 56 78',
    fuelAvailability: {
      essence: false,
      diesel: true,
    },
    openingHours: '06:00 - 21:30',
    isOperational: true,
  },
  {
    id: '14',
    code: 'OE-NIA',
    name: 'Oryx Energies Niamakoro',
    location: 'Niamakoro',
    commune: 'Commune IV',
    riverSide: 'RG',
    pumps: 6,
    prices: {
      essence: 740,
      diesel: 670,
    },
    capacity: 37000,
    managerContact: '+223 76 45 67 89',
    fuelAvailability: {
      essence: true,
      diesel: true,
    },
    openingHours: '06:00 - 22:00',
    isOperational: true,
  },
  {
    id: '15',
    code: 'TE-SEB',
    name: 'Total Energies Sebenikoro',
    location: 'Sebenikoro',
    commune: 'Commune VI',
    riverSide: 'RD',
    pumps: 7,
    prices: {
      essence: 750,
      diesel: 680,
      gpl: 520,
    },
    capacity: 44000,
    managerContact: '+223 76 56 78 90',
    fuelAvailability: {
      essence: true,
      diesel: true,
      gpl: false,
    },
    openingHours: '06:00 - 22:30',
    isOperational: true,
  },
]
